<ng-container *transloco="let t">
  <div class="flex min-h-0 flex-col gap-6">
    @if (data.subtitle) {
      <span class="text-text-tertiary">{{ data.subtitle }}</span>
    }

    <pxc-media-picker
      #picker="pxcMediaPicker"
      [accept]="data.accept ?? 'image/*'"
      [groups]="groups()"
      [hasMore]="hasMore()"
      [isLoadingMore]="isLoadingMore()"
      [isLongVideoEnabled]="data.isLongVideoEnabled ?? false"
      [itemTemplate]="data.itemTemplate"
      [maxFileSize]="data.maxFileSize"
      [maxSelectable]="data.maxSelectable"
      [preselectedFiles]="data.preselectedFiles ?? []"
      [preselectedMediaIds]="data.preselectedMediaIds ?? []"
      [validators]="data.validators ?? []"
      (loadMoreRequest)="data.onLoadMore?.()"
      (uploadedFilesChange)="data.onUploadedFilesChange?.($event)" />

    <div class="flex gap-2 max-md:flex-col-reverse md:items-center">
      <button appearance="outline" tuiButton type="button" (click)="onCancelled()">
        {{ t('Annuler') }}
      </button>
      @if (picker.selectedCount() > 0) {
        <span class="text-sm text-text-tertiary md:ml-auto md:text-right" data-testid="media-picker-selection-count">
          {{ t('{count, plural, one {1 élément sélectionné} other {# éléments sélectionnés}}', { count:
          picker.selectedCount() }) }}
        </span>
      }
      <button
        class="md:ml-auto"
        data-testid="media-picker-confirm"
        tuiButton
        type="button"
        [class.md:ml-2!]="picker.selectedCount() > 0"
        [disabled]="picker.isConfirmDisabled()"
        (click)="onConfirmed(picker.selection())">
        {{ data.confirmLabel ?? t('Confirmer') }}
      </button>
    </div>
  </div>
</ng-container>
